import { Button } from "../ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../ui/select";
import { FileSpreadsheet, FileDown, Loader2 } from "lucide-react";

const YearSelect = ({ label, value, onChange, years, allLabel, testid }) => (
  <div>
    <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-1">{label}</div>
    <Select value={String(value)} onValueChange={onChange}>
      <SelectTrigger className="w-44 h-10 bg-white" data-testid={testid}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {allLabel && <SelectItem value="all" data-testid={`${testid}-all`}>{allLabel}</SelectItem>}
        {years.map((y) => (
          <SelectItem key={y} value={String(y)} data-testid={`${testid}-${y}`}>{y}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export const AdvancesFilters = ({ report, tripYear, issueYear, onTripYear, onIssueYear, onExport, exporting }) => (
  <div className="flex flex-wrap items-end gap-4">
    <YearSelect
      label="Año de inicio del viaje"
      value={tripYear}
      onChange={(v) => onTripYear(Number(v))}
      years={report?.trip_years || [tripYear]}
      testid="advances-trip-year"
    />
    <YearSelect
      label="Año de facturación"
      value={issueYear || "all"}
      onChange={(v) => onIssueYear(v === "all" ? null : Number(v))}
      years={report?.issue_years || []}
      allLabel="Todos los años"
      testid="advances-issue-year"
    />
    <div className="flex flex-wrap gap-2 sm:ml-auto">
      {[["xlsx", "Exportar Excel", FileSpreadsheet], ["pdf", "Exportar PDF", FileDown]].map(([fmt, label, Icon]) => (
        <Button
          key={fmt}
          variant="outline"
          onClick={() => onExport(fmt)}
          disabled={!report?.count || !!exporting}
          data-testid={`advances-export-${fmt}`}
        >
          {exporting === fmt
            ? <Loader2 size={15} className="mr-2 animate-spin" />
            : <Icon size={15} className="mr-2" />}
          {label}
        </Button>
      ))}
    </div>
  </div>
);
